import React, {useState, useEffect} from 'react';
import ResourceSectionsService, {ResourceSection} from 'src/services/ResourceSectionsService';
import Icon from 'shared/components/icon';
import {titleize} from 'shared/utils';
import {Link} from 'react-router-dom';
import EditResourcesForCategory from 'src/views/admin/EditResourcesForCategory';

interface ResourceSectionProps {
  match: {
    params: {
      id: string;
    };
  };
}

const EditResourceSection = (props: ResourceSectionProps): React.ReactElement | null => {
  const [resourceSection, setResourceSection] = useState<ResourceSection | null>(null);

  useEffect(() => {
    ResourceSectionsService.show(props.match.params.id).then(setResourceSection);
  }, []);

  if (!resourceSection) {
    return null;
  }

  return (
    <div>
      <Link to="/admin/tools/resource-sections">
        <Icon iconType="chevron-left" className="chevron-left" /> Resource Sections
      </Link>
      <h1 className="shared-font title">{titleize(resourceSection.name.replace(/\-/g, ' '))}</h1>
      <p className="shared-font subheading">{resourceSection.description}</p>
      <img style={{maxWidth: '400px'}} src={resourceSection.screenshot} />
      {resourceSection.resourceCategories.map((resourceCategory) => (
        <div key={resourceCategory.title}>
          <h2 className="shared-font subheading">{resourceCategory.title}</h2>
          <EditResourcesForCategory
            category={resourceCategory.title}
            userTypes={resourceSection.userTypes}
          />
        </div>
      ))}
    </div>
  );
};

export default EditResourceSection;
